module.exports = __webpack_public_path__ + "img/car.b2fd4649.svg";